// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneAPIModel
 */
export interface PhoneAPIModel {
    /**
     * 
     * @type {string}
     * @memberof PhoneAPIModel
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof PhoneAPIModel
     */
    status: PhoneAPIModelStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum PhoneAPIModelStatusEnum {
    Verified = 'Verified',
    NotVerified = 'NotVerified'
}

export function PhoneAPIModelFromJSON(json: any): PhoneAPIModel {
    return PhoneAPIModelFromJSONTyped(json, false);
}

export function PhoneAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'number': json['number'],
        'status': json['status'],
    };
}

export function PhoneAPIModelToJSON(value?: PhoneAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'number': value.number,
        'status': value.status,
    };
}


